<template>  
  <v-container>
    <v-divider></v-divider>
    <v-card class="elevation-0" v-if="!dialogCarga">
      <v-tabs
        dense
        class="mt-4"
        v-model="tab"
        background-color="white"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab
          v-for="(item,i) in items"
          :key="i"
        >
          <v-icon v-text="item.icon" left></v-icon>{{ item.name }}
        </v-tab>
      </v-tabs>
    </v-card>
    <v-row v-if="!dialogCarga">
      <v-col cols="12">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-col cols="12" lg="8">
              <v-card class="elevation-0">
                <v-card-title primary-title class="pt-0">
                  Editar Artículo
                  <v-spacer></v-spacer>
                  <v-btn 
                    small
                    class="ma-2" 
                    color="secondary" 
                    :to="{name:'catproductos'}" 
                    dark>Atras
                  </v-btn>
                  <!-- BTN GUARDAR -->
                  <v-btn 
                    small 
                    dark 
                    class="ma-2" 
                    @click.prevent="update"
                    color="primary">Grabar
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-text-field
                    readonly
                    label="Código"
                    v-model="articulo.codigo"
                    validate-on-blur
                    class="pa-0"  
                    dense
                    outlined
                  ></v-text-field>

                  <v-switch 
                    v-model="articulo.estatus" 
                    label="Activo en tienda" 
                  ></v-switch>
                  
                  <v-text-field
                    label="Nombre del artículo"
                    v-model="articulo.nomart"
                    outlined 
                    dense
                  ></v-text-field>


                  <v-autocomplete 
                    dense
                    outlined
                    :items="familias"
                    v-model="familia"
                    item-text="familia"
                    item-value="idfamilia" 
                    label="Familia"
                    persistent-hint
                    hide-details
                    return-object
                    clearable
                    :append-outer-icon="familia ? 'mdi-plus-circle' : ''"
                    @click:append-outer="addFamilia"
                  ></v-autocomplete>
                  <v-row class="mb-5">
                    <v-col>
                      <v-chip
                        class="mr-2" 
                        v-for="(familia, i) in familiaDelArticulo"
                        :key="i"
                        color="primary"
                        close
                        @click:close="eliminarFamilia(familia.idfamilias_art)"
                      >{{ familia.familia }}</v-chip>
                    </v-col>
                  </v-row>

                  <v-autocomplete 
                    dense
                    outlined
                    :items="categorias"
                    v-model="categoria"
                    item-text="categoria"
                    item-value="idcategorias" 
                    label="Categoria"
                    persistent-hint
                    return-object
                    hide-details
                    :append-outer-icon="categoria ? 'mdi-plus-circle' : ''"
                    @click:append-outer="addCategoria"
                  ></v-autocomplete>
                  <v-row class="mb-5">
                    <v-col>
                      <v-chip
                        class="mr-2" 
                        v-for="(categoria, i) in categoriaDelArticulo"
                        :key="i"
                        color="primary"
                        close
                        @click:close="eliminarCategoria(categoria.idcategorias_art)"
                      >{{ categoria.categoria }}</v-chip>
                    </v-col>
                  </v-row>

                  <v-autocomplete 
                    dense
                    outlined
                    :items="subcategorias"
                    v-model="subcategoria"
                    item-text="subcategoria"
                    item-value="idsubcategorias" 
                    label="Subcategoria"
                    persistent-hint
                    return-object
                    hide-details
                    :append-outer-icon="subcategoria ? 'mdi-plus-circle' : ''"
                    @click:append-outer="addsubCategoria"
                  ></v-autocomplete>
                  <v-row class="mb-5">
                    <v-col>
                      <v-chip
                        class="mr-2" 
                        v-for="(subcategoria, i) in subcategoriaDelArticulo"
                        :key="i"
                        color="primary"
                        close
                        @click:close="eliminarsubCategoria(subcategoria.idsubcategorias_art)"
                      >{{ subcategoria.subcategoria }}</v-chip>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-autocomplete 
                        dense
                        outlined
                        :items="tipos"
                        v-model="articulo.idtipos"
                        item-text="tipo"
                        item-value="idtipos" 
                        label="Tipo"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete 
                        dense
                        outlined
                        :items="efectos"
                        v-model="articulo.idefectos"
                        item-text="efecto"
                        item-value="idefectos" 
                        label="Efecto"
                        persistent-hint
                        hide-details
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete 
                        dense
                        outlined
                        :items="aromas"
                        v-model="articulo.idaromas"
                        item-text="aroma"
                        item-value="idaromas" 
                        label="Aroma"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="6">
                      <v-autocomplete 
                        dense
                        outlined
                        :items="sabores"
                        v-model="articulo.idsabores"
                        item-text="sabor"
                        item-value="idsabores" 
                        label="Sabor"
                        persistent-hint
                      ></v-autocomplete>
                    </v-col>
                  </v-row>

                  <v-textarea
                    label="Descripción corta"
                    v-model="articulo.descrip"
                    outlined 
                    auto-grow
                  >
                  </v-textarea>

                  <v-textarea
                    label="Descripción Larga"
                    v-model="articulo.descripLarga"
                    outlined 
                    auto-grow
                  >
                  </v-textarea>
                    
                  <v-alert type="error" :value="alertaInput">
                    {{alerta}}
                  </v-alert>
                </v-card-text>
              </v-card>
            </v-col>
          </v-tab-item>

          <v-tab-item>
            <v-col cols="12" lg="8">
              <v-card class="elevation-0">
                <v-card-title primary-title>
                  Sube tus imagenes masivamente
                  <v-spacer></v-spacer>
                  <v-btn 
                    small
                    class="ma-2" 
                    color="secondary" 
                    :to="{name:'catproductos'}" 
                    dark>Atras
                  </v-btn>
                  <v-btn color="primary" small @click="subirFotos()">Subir Fotos</v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-file-input
                    outlined
                    dense
                    small-chips
                    multiple
                    v-model="files"
                    accept="image/png, image/jpeg, image/bmp"
                    placeholder="Selecciona tus imagenes"
                    prepend-icon="mdi-camera"
                    label="Imágenes"
                    @change="cargarF()"
                  ></v-file-input>
                </v-card-text>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xl="4" lg="4" md="4" sm="5" xs="6" v-for="(img, i) in vistaPrevias" :key="i">
                      <v-card class="py-2">
                        <v-img :src="img.url" contain aspect-ratio="2">
                          <v-row align="end" class="lightbox white--text pa-2 fill-height">
                            <v-col align="right">
                              <v-btn color="error" samll @click="eliminarFoto(img.url)" icon><v-icon>delete</v-icon></v-btn>
                            </v-col>
                          </v-row>
                        </v-img>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <v-card class="elevation-0">
                <v-card-title primary-title>
                  Imágenes actuales
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" xl="4" lg="4" md="4" sm="5" xs="6" v-for="(f, i) in fotos" :key="i">
                      <v-card height="100%">
                        <v-img :src="url + f.image_name" contain height="150"/>
                        <v-card-actions>
                          <v-btn icon color="error" @click="deleteFoto(f.idfotos)"><v-icon>delete</v-icon></v-btn>
                          <v-spacer></v-spacer>
                          <v-checkbox label="Principal" v-model="f.principal" @click="updateEestatus(f.idfotos)"></v-checkbox>
                        </v-card-actions>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-tab-item>

          <v-tab-item>
            <v-card class="elevation-0">
              <v-card-title primary-title>
                Precio del artículo 
                <v-spacer></v-spacer>
                <v-btn 
                    small
                    class="ma-2" 
                    color="secondary" 
                    :to="{name:'catproductos'}" 
                    dark>Atras
                  </v-btn>
                <v-btn color="primary" @click="update" small>Actualizar</v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" xl="3" lg="3" md="4" sm="4" xs="6">
                    <v-text-field
                      label="Precio"
                      v-model = "articulo.precio1"
                      type="number"
                      prefix="$"
                      suffix="MXN"
                      outlined
                      dense
                    ></v-text-field>

                    <v-text-field
                      label="% Descuento"
                      v-model = "articulo.pjedesc"
                      type="number"
                      prefix="%"
                      @change="calcularDescuento()"
                      outlined
                      dense
                    ></v-text-field>

                    <v-text-field
                      v-model="preciowithdescuento"
                      label="Precio con descuento"
                      prefix="$"
                      suffix="MXN"
                      outlined
                      readonly
                      dense
                    ></v-text-field>

                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item>
            <v-card class="elevation-0">
              <v-card-title primary-title>
                Datos de envío
                <v-spacer></v-spacer>
                <v-btn 
                    small
                    class="ma-2" 
                    color="secondary" 
                    :to="{name:'catproductos'}" 
                    dark>Atras
                  </v-btn>
                <v-btn color="primary" @click="update" small>Actualizar</v-btn>
              </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" xl="3" lg="3" md="4" sm="4" xs="6">
                    <v-text-field
                      label="Peso"
                      v-model = "articulo.peso"
                      type="number"
                      prefix=""
                      suffix="KG"
                      outlined
                      dense
                    ></v-text-field>

                    <v-text-field
                      label="alto"
                      v-model = "articulo.alto"
                      type="number"
                      prefix=""
                      suffix="cm"
                      outlined
                      dense
                    ></v-text-field>

                    <v-text-field
                      label="largo"
                      v-model = "articulo.largo"
                      type="number"
                      prefix=""
                      suffix="cm"
                      outlined
                      dense
                    ></v-text-field>

                    <v-text-field
                      label="ancho"
                      v-model = "articulo.ancho"
                      type="number"
                      prefix=""
                      suffix="cm"
                      outlined
                      dense
                    ></v-text-field>


                    <v-select
                      :items="['Sobre','Caja']"
                      label="ancho"
                      v-model = "envoltorio"
                      type="number"
                      outlined
                      dense
                    ></v-select>

                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
             
    <!-- SNACK BAR -->
    <v-snackbar
      v-model="snackbar"
      :timeout="8000"
      top
      :color="color" 
      >
      {{text}}
      <v-btn
        color="white"
        text
        @click="snackbar = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>

    <v-dialog
      v-model="dialogCarga"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Cargando, espere por favor...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex'
  export default {
    data () {
      return {
        envoltorio:'',
        dialogCarga:false,
        id: 0,
        statusweb: false,
        producto:{},
        articulo:{},

        tab: {name:'Información'            , icon:'insert_drive_file' }, 
        items: [
          {name:'Información'      , icon:'insert_drive_file' }, 
          {name:'Imágemes'         , icon:'insert_drive_file' }, 
          {name:'Precios'          , icon:'assignment' }, 
          {name:'Datos Envío'       , icon:'local_taxi' }, 
        ],

        familia:null,

        existe: true,

        snackbar: false,
        text:'',
        color:'',

        codigo:'',
        result2:'',
        nomart:'',
        sal:'',
        lab:'',

        alerta:'',
        alertaInput: false,

        categorias:[],
        categoria:null,

        familias:[],
        familia:null,

        subcategorias:[],
        subcategoria:null,

        preciowithdescuento:0,

        url:'',
        fotos:[],
        rules: [
          value => !value ,
        ],
        files: [],
        vistaPrevias:[],

        familiaDelArticulo:[],
        categoriaDelArticulo:[],
        subcategoriaDelArticulo:[],

        tipos:[],
        tipo:null,
        sabores:[],
        sabor:null,
        efectos:[],
        efecto: null,
        aromas:[],
        aroma: null,
      }
    },


    computed: {
      ...mapGetters('productos',['getProducto']),
      validaInfo(){
        return  this.nomart      !==  '' && 
                this.sal         !==  '' &&       
                this.laboratorio.idlaboratorios         !==  '' 
      },
    },

    watch:{
      familia () {
        this.categorias = []
        if(this.familia){
          this.$http.get('categorias.familia/'+ this.familia.idfamilias).then(response=>{
            this.categorias = response.body
          }).catch(error=>{
            this.existe = false
            console.log('error',error)
          })
        }
      },

      categoria () {
        this.subcategorias = []
        if(this.categoria){
          this.$http.get('subcategorias.categoria/'+ this.categoria.idcategorias).then(response=>{
            this.subcategorias = response.body
          }).catch(error=>{
            this.existe = false
            console.log('error',error)
          })
        }
      },

    },

    async created(){
      this.dialogCarga = true
      await this.init()
      await this.consultarFamilias()
      await this.cargarArticulo()
      await this.cargarFotosArt()
      await this.categoriasArt()
      await this.familiasArt()
      await this.categoriasArt()
      await this.subcategoriasArt()
      await this.getTipos()
      await this.getSabores()
      await this.getAromas()
      await this.getEfectos()
      this.dialogCarga = false
    },

    methods:{

      getTipos () {
        this.cargar = true
        this.tipos = []
        return this.$http.get('tipos.list').then(response=>{
          this.tipos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getSabores () {
        this.cargar = true
        this.sabores = []
        return this.$http.get('sabores.list').then(response=>{
          this.sabores = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getAromas () {
        this.cargar = true
        this.aromas = []
        return this.$http.get('aromas.list').then(response=>{
          this.aromas = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getEfectos () {
        this.cargar = true
        this.efectos = []
        return this.$http.get('efectos.list').then(response=>{
          this.efectos = response.body
          this.cargar      = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      cargarArticulo () {
        return this.$http.get('articulos.id/' + this.id).then(response=>{
          this.articulo = response.body
          if(this.articulo.envoltorio == 'envelope'){this.envoltorio = 'Sobre'}else{this.envoltorio = 'Caja'}
        }).catch(error=>{
          console.log('error',error)
        })
      },

      cargarFotosArt () {
        // Cargar las fotos
        return this.$http.get('articulos.fotos/' + this.articulo.codigo).then(response=>{
          if(response.data.length > 0){
            this.fotos = response.data
            this.fotos.forEach((element)=>{
              element.principal = !! +element.principal
            })
          }
        }).catch(error=>{console.log(error)})
      },

      familiasArt () {
        return this.$http.get("familias.art.id/" + this.id).then(response=>{
          this.familiaDelArticulo = response.body
        }).catch(error=>{console.log(error)})
      },

      categoriasArt () {
        return this.$http.get("categorias.art.id/" + this.id).then(response=>{
          this.categoriaDelArticulo = response.body
        }).catch(error=>{console.log(error)})
      },

      subcategoriasArt () {
        return this.$http.get("subcategorias.art.id/" + this.id).then(response=>{
          this.subcategoriaDelArticulo = response.body
        }).catch(error=>{console.log(error)})
      },

      init () {
        this.url = this.$http.options.root + 'fotos-epic-grass/'
        this.fotos = this.getProducto.fotos
        this.codigo = this.getProducto.codigo
        this.id = this.getProducto.id
        return 
      },

      consultarFamilias () {
        return this.$http.get('familias.activo').then(response=>{
          this.familias = response.body
        }).catch(error=>{
          console.log('error',error)
        })
      },

      update(){
        if(this.familia){      this.articulo.idfamilias =      this.familia.idfamilias}
        if(this.categoria){    this.articulo.idcategorias =    this.categoria.idcategorias}
        if(this.subcategoria){ this.articulo.idsubcategorias = this.subcategoria.idcategorias}


        if(this.articulo.estatus == true){
          this.articulo.estatus = 1
        }else{
          this.articulo.estatus = 0
        }

        if(this.envoltorio == 'Sobre'){this.articulo.envoltorio = 'envelope'}else{this.articulo.envoltorio = 'box'}

        this.$http.put('articulos.update/'+ this.id, this.articulo).then(response=>{
          this.text  = 'Artículo actualizado'
          this.snackbar = true
          this.color = 'success'
        }).catch(error=>{console.log(error)})
      },

      calcularDescuento(){
        if(this.articulo.pjedesc > 0){
          this.preciowithdescuento = ((100 - this.articulo.pjedesc)/100) * this.articulo.precio1
        }else{
          this.preciowithdescuento = 0
        }
      },

      cargarFotos(){
        var url2 = this.$http.options.root + 'fotos-epic-grass/'
        this.url = url2
        this.fotos = []
        this.$http.get('articulos.fotos/' + this.articulo.codigo).then(response=>{
          if(response.data.length > 0){
            this.fotos = response.data
            this.fotos.forEach((element)=>{
              element.principal = !! +element.principal
            })
          }
        }).catch(error=>{console.log(error)})
      },

      cargar(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          console.log('formdata', formData);
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name
          })
        };
        console.log('vistass', this.vistaPrevias);
      },

      subirFotos(){
        // Recorremos las imagenes previas cargadas para poder agregarlas al servidor y guardar el nombre en la base de datos
        this.vistaPrevias.forEach((element, index) => {
          var payload = {
            codigo: this.articulo.codigo,
            image_name: element.image_name,
            principal: 0
          }
          this.$http.post('fotos.add', payload).then(response=>{
            // Mandamos el formdata (archivo de la imagen) al servidor
            this.$http.post('imagenes', element.formData).then(response=>{
              //  y se gguar tambien en la base de datos, solo se guarda el nombre de la imagen
              if(index == 0){
                this.text  = 'Artículo actualizado'
                this.snackbar = true
                this.color = 'success'
                // Limpiamos las imagenes previas ya cuando se haya terminado el recorrido del foreach
                this.vistaPrevias = []
                this.files = []
                this.cargarFotos()
              }
            }).catch(error=>{console.log(error)})
          }).catch(error=>{console.log(error)})
        })
      },

      eliminarFoto(value){
        this.vistaPrevias.forEach((element, index)=>{
          if(element.url == value){
            this.vistaPrevias.splice(index,1);
          }
        })
      },

      deleteFoto(value){
        this.$http.delete('admin/foto.art.delete/' + value).then(response=>{
          this.cargarFotos()
        }).catch(error=>{console.log(error)})
      },

      updateEestatus(id){
        this.fotos.forEach((element,index)=>{
          if(element.idfotos == id){
            element.principal = 1
          }else{
            element.principal = 0
          }
          this.$http.put('update.foto.principal/' + element.idfotos, element).then(response=>{
          }).catch(error=>{console.log(error)})
          if(index == this.fotos.length - 1){
            this.cargarFotos()
          }
        })
      },

      eliminarFamilia (val) {
        this.$http.delete("familias.art.delete/" + val).then(response=>{
          this.familiasArt().then((result)=>{
            this.text  = 'Familia eliminada'
            this.snackbar = true
            this.color = 'success'
          })
        }).catch(error=>{console.log(error)})
      },

      addFamilia () {
        const existenciaFamilia = this.familiaDelArticulo.find(articulo => articulo.idfamilias == this.familia.idfamilias)
        if(existenciaFamilia){
          this.text  = 'Familia ya existe'
          this.snackbar = true
          this.color = 'warning'
        }else{
          var payload = {
            idfamilias: this.familia.idfamilias,
            idarticulo: this.id 
          }
          this.$http.post("familias.art.add",payload).then(response=>{
            this.familiasArt().then((result)=>{
              this.text  = 'Familia agregada'
              this.snackbar = true
              this.color = 'success'
            })
          }).catch(error=>{console.log(error)})
        }
      },

      addCategoria () {
        const existenciacategoria = this.categoriaDelArticulo.find(articulo => articulo.idcategorias == this.categoria.idcategorias)
        if(existenciacategoria){
          this.text  = 'categoria ya existe'
          this.snackbar = true
          this.color = 'warning'
        }else{
          var payload = {
            idcategorias: this.categoria.idcategorias,
            idarticulo: this.id 
          }
          this.$http.post("categorias.art.add",payload).then(response=>{
            this.categoriasArt().then((result)=>{
              this.text  = 'categoria agregada'
              this.snackbar = true
              this.color = 'success'
            })
          }).catch(error=>{console.log(error)})
        }
      },

      eliminarCategoria (val) {
        this.$http.delete("categorias.art.delete/" + val).then(response=>{
          this.categoriasArt().then((result)=>{
            this.text  = 'categoria eliminada'
            this.snackbar = true
            this.color = 'success'
          })
        }).catch(error=>{console.log(error)})
      },

      addsubCategoria () {
        const existenciacategoria = this.subcategoriaDelArticulo.find(articulo => articulo.idcategorias == this.categoria.idcategorias)
        if(existenciacategoria){
          this.text  = 'categoria ya existe'
          this.snackbar = true
          this.color = 'warning'
        }else{
          var payload = {
            idsubcategorias: this.subcategoria.idsubcategorias,
            idarticulo: this.id 
          }
          this.$http.post("subcategorias.art.add",payload).then(response=>{
            this.subcategoriasArt().then((result)=>{
              this.text  = 'categoria agregada'
              this.snackbar = true
              this.color = 'success'
            })
          }).catch(error=>{console.log(error)})
        }
      },
      
      eliminarsubCategoria (val) {
        this.$http.delete("subcategorias.art.delete/" + val).then(response=>{
          this.subcategoriasArt().then((result)=>{
            this.text  = 'categoria eliminada'
            this.snackbar = true
            this.color = 'success'
          })
        }).catch(error=>{console.log(error)})
      },
      cargarF(){
        if(this.files.length < 1){
          return
        }

        this.files.forEach((element, index) => {
          // creamos una variable tipo FormData
          let formData = new FormData();
          //se crea el objeto y se le agrega como un apendice el archivo 
          formData.append('file', element);
          //mandamos a ocvertir la imagen a base64 pero mandamos el docuemnto, el formdata, el nombre
          console.log('formdata', formData);
          this.getBase64(element, formData)
        })
      },

      getBase64(file, formData) {
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
          console.log(file)
          me.vistaPrevias.push({
            url: reader.result, 
            formData: formData, 
            image_name: file.name
          })
        };
      },
    }

  }

</script>